import React from 'react';

import CircleExclamation from '@gravity-ui/icons/CircleExclamation';
import { Card } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/AliceSkillForm';
import * as intentsKeyset from 'i18n/IntentsPage';

const t = i18n(keyset);
const tIntents = i18n(intentsKeyset);

import styles from './DevPreviewBanner.module.scss';

export const DevPreviewBanner = () => {
    return (
        <Card className={styles.devPreviewBanner__container} theme={'info'}>
            <div className={styles.devPreviewBanner__header}>
                {<CircleExclamation />}
                {tIntents('warning-title')}
            </div>
            <p className={styles.devPreviewBanner__text}>{t('attention-func-in-dev')}</p>
        </Card>
    );
};
